var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchManager(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 144,
    height: 104,
    rx: 12,
    fill: "#EAF7F1",
    stroke: "#B6E6CE",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 96,
    height: 16,
    rx: 8,
    fill: "#18B46A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 60,
    width: 96,
    height: 16,
    rx: 8,
    fill: "#2BC77E",
    opacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 84,
    width: 96,
    height: 16,
    rx: 8,
    fill: "#35D990",
    opacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 44,
    r: 6,
    fill: "#F4F9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 68,
    r: 6,
    fill: "#F4F9FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 92,
    r: 6,
    fill: "#F4F9FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 24,
    width: 32,
    height: 8,
    rx: 4,
    fill: "#25416A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 18,
    width: 56,
    height: 4,
    rx: 2,
    fill: "#25416A",
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 30L132 36L120 42V30Z",
    fill: "#25416A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108H120",
    stroke: "#B6E6CE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchManager);
export default __webpack_public_path__ + "static/media/match-manager.4b3902bcd6fff2b2ea40ca2ef7865984.svg";
export { ForwardRef as ReactComponent };